import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

export interface FAQ {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  public faqs: FAQ[] = [];
  public notFilteresFaqs: FAQ[] = [];
  public searchValue: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.initializeFaqs();
    
    // Suscribirse a cambios de idioma para recargar las FAQs
    this.translateService.onLangChange.subscribe(() => {
      this.initializeFaqs();
    });
  }

  public initializeFaqs(): void {
    this.faqs = [
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q1'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A1') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q2'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A2') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q3'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A3') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q4'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A4') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q5'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A5') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q6'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A6') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q7'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A7') 
      },
      { 
        question: this.translateService.instant('FAQ.QUESTIONS.Q8'), 
        answer: this.translateService.instant('FAQ.ANSWERS.A8') 
      }
    ];

    this.notFilteresFaqs = this.faqs;
  }

  public filterFaqsElements(): void {
    if (this.searchValue.length === 0) {
      this.faqs = this.notFilteresFaqs;
      return;
    }

    this.faqs = this.notFilteresFaqs.filter(
      element => element.question.toLowerCase().includes(this.searchValue.toLowerCase())
        || element.answer.toLowerCase().includes(this.searchValue.toLowerCase())
    );
  }
}
